import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import global from 'global';
import deepFreeze from 'deep-freeze';
import _cloneDeep from 'lodash/cloneDeep';
import _isPlainObject from 'lodash/isPlainObject';
import _set from 'lodash/set';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import invariant from 'invariant';
import warning from 'warning';

var Config = function () {
  function Config(configuration) {
    _classCallCheck(this, Config);

    this._isInitialized = false;

    if (configuration) {
      this.init(configuration);
    }
  }

  _createClass(Config, [{
    key: "isInitialized",
    get: function get() {
      return this._isInitialized;
    }
  }, {
    key: "init",
    value: function init() {
      var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      invariant(!this._isInitialized, "[@insolus/config] La configuration a d\xE9j\xE0 \xE9t\xE9 initialis\xE9e.");
      this._isInitialized = true;
      invariant(_isPlainObject(configuration), "La configuration pass\xE9e \xE0 `@insolus/config` doit \xEAtre sous forme " + "d'objet litt\xE9ral (e.g. `{ key: [value] }`), \xE0 la place, un type " + "\"".concat(typeof configuration, "\" a \xE9t\xE9 re\xE7u."));

      var _configuration = _cloneDeep(configuration);

      if ('__SERVER_CONFIG__' in global && global.__SERVER_CONFIG__ !== undefined) {
        invariant(_isPlainObject(global.__SERVER_CONFIG__), "La configuration serveur `__SERVER_CONFIG__` doit \xEAtre sous forme " + "d'objet litt\xE9ral (e.g. `{ key: [value] }`), \xE0 la place, un type " + "\"".concat(typeof global.__SERVER_CONFIG__, "\" a \xE9t\xE9 re\xE7u."));

        var _loop = function _loop(object) {
          var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          Object.keys(object).forEach(function (key) {
            var value = object[key];
            var path = basePath + key;

            if (!_has(_configuration, path)) {
              _set(_configuration, "serverContext.".concat(path), value);

              return;
            }

            var _configValue = _get(_configuration, path);

            var _isOverwritableValue = !_isPlainObject(_configValue) || _isEmpty(_configValue);

            if (!_isPlainObject(value) || _isOverwritableValue) {
              _set(_configuration, path, value);

              return;
            }

            _loop(value, "".concat(path, "."));
          });
        };

        _loop(global.__SERVER_CONFIG__);
      }

      warning(!_isEmpty(_configuration), "Une configuration vide va \xEAtre assign\xE9e \xE0 `@insolus/config`, cela signifie qu'il n'y " + "aura strictement rien \xE0 lire avec `Config.get()`, ce comportement n'est sans doute pas " + "celui d\xE9sir\xE9.");
      this._store = deepFreeze(_configuration);
      return this;
    }
  }, {
    key: "reset",
    value: function reset(newConfiguration) {
      this._store = {};
      this._isInitialized = false;

      if (newConfiguration) {
        this.init(newConfiguration);
      }
    }
  }, {
    key: "get",
    value: function get(key, defaultValue) {
      this._ensureInitialized();

      invariant(!(defaultValue === undefined && !this.has(key)), "[@insolus/config] La cl\xE9 de configuration \"".concat(key, "\" est requise pourtant celle-ci est ind\xE9finie.\n") + "(Si celle-ci est optionnelle, veuillez d\xE9finir une valeur par d\xE9faut lors de la r\xE9cup\xE9ration: " + "`Config.get('".concat(key, "', '[Valeur par d\xE9faut]')`)"));
      return _get(this._store, key, defaultValue);
    }
  }, {
    key: "has",
    value: function has(key) {
      this._ensureInitialized();

      return _has(this._store, key);
    }
  }, {
    key: "_ensureInitialized",
    value: function _ensureInitialized() {
      warning(this._isInitialized, "[@insolus/config] L'initialisation (`Config.init({ ... })`) doit \xEAtre effectu\xE9e avant " + "tout appel aux m\xE9thodes d'int\xE9raction avec les donn\xE9es de `Config`.");
    }
  }]);

  return Config;
}();

export default Config;